/*eslint-disable */
import root from '../_helpers/roots';
import axios from 'axios';
let OrgListUrl = root.organizationListUrl.link;
let AcOrgUserUrl = root.acOrgUserUrl.link;
let superAdminUrl = root.orgUserChangeToAdminUrl.link;
let SuAcUpdatesUrl = root.suAcUpdatesUrl.link;
import Vue from 'vue'
export default {
  state: {
    OrgListDataState:{},
    orgUserDetailsByIdState:{},
    OrgDetailByIdState:{},
    OrgUserDetailByIdState:{},
    getSuAcUpdatesListState:{},
    getSuAcUpdatesListByIdState:{}
  },
  mutations: {
    getOrgListDataMut(state, value) {
      Vue.set(state, 'OrgListDataState', value);
    }, 
    getOrgDetailsByIdMut(state, value) {
      Vue.set(state, 'OrgDetailByIdState', value);
    }, 
    getUserDetailsByIdMut(state, value) {
      Vue.set(state, 'orgUserDetailsByIdState', value);
    },
    getOrgUserDetailsByIdMut(state, value) {
      Vue.set(state, 'OrgUserDetailByIdState', value);
    },
    getSuAcUpdatesListMut(state, value) {
      Vue.set(state, 'getSuAcUpdatesListState', value);
    },
    getSuAcUpdatesListByIdMut(state, value) {
      Vue.set(state, 'getSuAcUpdatesListByIdState', value);
    }
  },
  actions: {
    // Get Organization List Details
    getOrgListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(OrgListUrl + '?is_deleted=1' + '/', payload).then(res => {
              context.commit('getOrgListDataMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    }, 
    // Get Organization Details By Id
    getOrgDetailsByIdFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(OrgListUrl + payload.id + '/').then(res => {
              context.commit('getOrgDetailsByIdMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create Account Organization Details
    createAcOrgFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(OrgListUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Account Organization Details By Id 
    updateAcOrgFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(OrgListUrl + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Remove Account Organization Details
    removeAcOrgFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(OrgListUrl + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create Account USer Details
    createAcUserFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(AcOrgUserUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Org User Details
    getOrgUseDetailsByIdFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(AcOrgUserUrl + payload.id + '/').then(res => {
              context.commit('getUserDetailsByIdMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Org User Details
    updateOrgUseDetailsByIdFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(AcOrgUserUrl + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Remove Organization User Details
    removeOrgUserFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(AcOrgUserUrl + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Organization User Details By Id
    getOrgUserDetailsByIdFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(AcOrgUserUrl + payload.id + '/').then(res => {
              context.commit('getOrgUserDetailsByIdMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Make The Super Admin
    makeSuperAdminFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(superAdminUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Su Ac Updates List
    getSuAcUpdatesListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(SuAcUpdatesUrl).then(res => {
              context.commit('getSuAcUpdatesListMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Su Ac Updates List
    getSuAcUpdatesListByIdFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(SuAcUpdatesUrl + payload.id + '/').then(res => {
              context.commit('getSuAcUpdatesListByIdMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create Su Ac Updates List
    createSuAcUpdatesListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(SuAcUpdatesUrl,payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Su Ac Updates List
    updateSuAcUpdatesListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(SuAcUpdatesUrl + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Remove Su Ac Updates List
    removeSuAcUpdatesListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(SuAcUpdatesUrl + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    }
  },
  getters: {
    OrgListDataGetters: state => state.OrgListDataState,
    orgUserDetailsByIdGetters: state => state.orgUserDetailsByIdState,
    OrgDetailByIdGetters: state => state.OrgDetailByIdState,
    OrgUserDetailByIdGetters: state => state.OrgUserDetailByIdState,
    getSuAcUpdatesListGetters: state => state.getSuAcUpdatesListState,
    getSuAcUpdatesListByIdGetters: state => state.getSuAcUpdatesListByIdState
  }
}